import { useWarrantyClaimContext } from '@components';
import { FormControl, FormControlLabel, InputLabel, Radio, RadioGroup } from '@mui/material';

import { TextCodes } from '@api/types/translation/TextCodes';
import { t } from '@translations';
import { Controller } from 'react-hook-form';

export const WarrantyPurchaseSelect = () => {
  const { form, isReadOnly } = useWarrantyClaimContext();

  return (
    <Controller
      control={form.control}
      name='purchase'
      render={({ field }) => (
        <FormControl sx={{ mt: 5, width: '100%' }}>
          <InputLabel id='purchase-type'>{t(TextCodes.Warranty.Block.PurchaseType)}</InputLabel>
          <RadioGroup {...field}>
            <FormControlLabel
              value='Private'
              control={<Radio disabled={isReadOnly && field.value !== 'Private'} />}
              label={t(TextCodes.Warranty.Block.Private)}
              sx={{
                width: 'fit-content',
              }}
            />
            <FormControlLabel
              sx={{ mt: 1, width: 'fit-content' }}
              value='Company'
              control={<Radio disabled={isReadOnly && field.value !== 'Company'} />}
              label={t(TextCodes.Warranty.Block.Company)}
            />
          </RadioGroup>
        </FormControl>
      )}
    />
  );
};
